import  { useEffect, useState } from 'react';
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/style.css";
import "../../css/responsive.css";
import "../../css/light-color.css";
import "../../css/floatlabel.css";
import "../../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import  Header  from '../../components/sections/mainwebsite/Header';
import ScrollToTop from 'react-scroll-to-top';
import { Footer } from '../../components/sections/footer';
import { AxiosInstance } from '../../components/utils';
import MainWebFooter from '../../components/sections/mainwebsite/mainwebfooter';

function PrivacyPolicy() {
      const [events, setEvents] = useState<any[]>([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await AxiosInstance.get('/api/getevent?eventstatus=OPEN,REGISTRATIONSCLOSED,REGISTRATIONSOPEN');
        if (response.data.result === 'Success') {
          setEvents(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, []);

    return (
        <>
            <div className="antialiased light-vz circle-v ">
                <Header events={events} />
                <h1 className='spacer-section'></h1>
                
                {/* Privacy Policy Section */}
                <section className="general-text">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                         
                        <div className="sec-title white-heading-text">
                            <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-file fa-stack-1x"></i></span></span>
                            <h3 className="wow fadeInRight" data-wow-duration="500ms">Privacy Policy</h3>
                        </div> {/* <!--sec-title end--> */}
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="conduct-content">
                                    <p>
                                        At BSides Bangalore, accessible from https://bsidesbangalore.in/, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains information that is collected and recorded by BSides Bangalore and how we use it.
                                    </p>
                                    <br/>
                                    <p>
                                        This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in BSides Bangalore. This policy is not applicable to any information collected offline or via channels other than this website.
                                    </p>
                                    <br/>
                                    
                                    <h2>Consent</h2>
                                    <p>
                                        By using our website, you hereby consent to our Privacy Policy and agree to its terms.
                                    </p>
                                    <br/>
                                    
                                    <h2>Information we collect</h2>
                                    <p>
                                        During and for the purpose of conference registration and related communication, BSides Bangalore may collect the following information:
                                    </p>
                                    <ul>
                                        <li>Name and job title</li>
                                        <li>Contact information including email address and phone number</li>
                                        <li>Demographic information such as postcode, preferences and interests</li>
                                    </ul>
                                    <br/>
                                    
                                    <h2>Use of Data</h2>
                                    <p>
                                        We collected data for various purposes:
                                    </p>
                                    <ul>
                                        <li>To provide and maintain our Service</li>
                                        <li>To notify you about changes to our Service</li>
                                        <li>To provide customer support</li>
                                        <li>To gather analysis or valuable information so that we can improve our Service</li>
                                        <li>To monitor the usage of our Service</li>
                                        <li>To detect, prevent and address technical issues</li>
                                        <li>To provide you with news and updates about us</li>
                                        <li>To send you a welcome email</li>
                                        <li>To assist with our analytical data</li>
                                        <li>To provide special information materials to you from us and/or our respective affiliates, subsidiaries and other third parties</li>
                                    </ul>
                                    <br/>
                                    
                                    <p>
                                        You have the right to opt out of any data communication by unsubscribing, by clicking on 'unsubscribe' where written on all electronic marketing communication data material
                                    </p>
                                    <br/>
                                    
                                    <h2>Third-Party Websites</h2>
                                    <p>
                                        Our Service may contain links to third-party websites. When you click on a link to any other website or location, you will leave our Service and go to another site, and another entity may collect Personal Data from you. We have no control over, do not review, and cannot be responsible for these third-party websites or their content. Please be aware that the terms of this Privacy Policy do not apply to these third-party websites or their content, or to any collection of your Personal Data after you click on links to such third-party websites. We encourage you to read the privacy policies of every website you visit. Any links to third-party websites or locations are for your convenience and do not signify our endorsement of such third parties or their products, content, or websites.
                                    </p>
                                    <br/>
                                    
                                    <h2>Third-Party Wallets</h2>
                                    <p>
                                        To use our Service, you must use a third-party wallet which allows you to engage in transactions on public blockchains. Your interactions with any third-party wallet provider are governed by the applicable terms of service and privacy policy of that third party.
                                    </p>
                                    <br/>
                                    
                                    <h2>Cookies</h2>
                                    <p>
                                        The BSides Bangalore website does not make use of cookies. A cookie is a small file that is placed on your hard drive to store certain information about the website and / or the user. It is used to manage user information and certain website functionality, although may also be used incorrectly to compromise user security. We do not make use of any such methods.
                                    </p>
                                    <br/>
                                    
                                    <h2>Analytics</h2>
                                    <p>
                                        BSides Bangalore does make use of website analytics and only stores information gathered through its users and visitors such as number of page views, day of visit, means of accessing the website, location, etc. Any personal data about the user or visitor is not collected. None of this information is gathered for any purpose other than our internal analysis and would not be handed over to any third party.
                                    </p>
                                    <br/>
                                    
                                    <h2>Children's Information</h2>
                                    <p>
                                        Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.
                                        BSides Bangalore does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.
                                    </p>
                                    <br/>
                                    
                                    <h2>Disclosure of Data</h2>
                                    <h3>Disclosure for Law Enforcement</h3>
                                    <p>
                                        Under certain circumstances, B-Sides Bangalore may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
                                    </p>
                                    <br/>
                                    
                                    <h3>Legal Requirements</h3>
                                    <p>
                                        B-Sides Bangalore may disclose your Personal Data in the good faith belief that such action is necessary to:
                                    </p>
                                    <ul>
                                        <li>To comply with a legal obligation</li>
                                        <li>To protect and defend the rights or property of B-Sides Bangalore</li>
                                        <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
                                        <li>To protect the personal safety of users of the Service or the public</li>
                                        <li>To protect against legal liability</li>
                                    </ul>
                                    <br/>
                                    
                                    <h2>Retention of Data</h2>
                                    <p>
                                        BSides Bangalore will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes and enforce our legal agreements and policies.
                                    </p>
                                    <br/>
                                    
                                    <h2>Contact Us</h2>
                                    <p>
                                        If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us at Info@bsidesbangalore.in
                                    </p>
                                     <br/> <br/> <br/> <br/> <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
               <MainWebFooter  />
                <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
            </div>
        </>
    );
}

export default PrivacyPolicy;